import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../../firebase';
import usersAPI from '../../api/users';
import SignupStep1 from '../signup/Step1';
import SignupStep2 from '../signup/Step2';
import SignupStep3 from '../signup/Step3';
import SignupStep4 from '../signup/Step4';
import SignupStep5 from '../signup/Step5';

export default function SignUpFlow() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialStep = parseInt(searchParams.get('step') || '1');
  const [step, setStep] = useState(initialStep);
  const [firebaseUid, setFirebaseUid] = useState('');
  const [email, setEmail] = useState('');
  const [collectedData, setCollectedData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.currentUser) {
      console.log('🔓 Signing out existing Firebase user on signup start');
      auth.signOut();
    }
  }, []);

  const handleStep1Complete = async (uid, email, isNewUser = false) => {
    const user = auth.currentUser;
    if (!user) {
      console.error('❌ Firebase user not ready');
      return;
    }

    try {
      const token = await user.getIdToken(true);
      console.log('✅ Firebase token:', token);
      console.log('🆕 Is new user?', isNewUser);

      if (isNewUser) {
        setFirebaseUid(uid);
        setEmail(email);
        setSearchParams({ step: '2' });
        setStep(2);
        return;
      }

      const res = await usersAPI.getProfile();
      alert("You already have an account. Please log in instead.");
      setTimeout(() => auth.signOut(), 1000);
      navigate('/login');
    } catch (err) {
      const status = err.response?.status;
      if (status === 403) {
        alert('This email is already registered. Please log in instead.');
        setTimeout(() => auth.signOut(), 1000);
        navigate('/login');
      } else if (status === 401) {
        setFirebaseUid(uid);
        setEmail(email);
        setSearchParams({ step: '2' });
        setStep(2);
      } else {
        console.error('❌ Unexpected error:', err.message);
      }
    }
  };

  const mergeAndNext = (data, nextStep) => {
    setCollectedData((prev) => ({ ...prev, ...data }));
    setSearchParams({ step: String(nextStep) });
    setStep(nextStep);
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      {step === 1 && (
        <SignupStep1 onComplete={handleStep1Complete} />
      )}
      {step === 2 && (
        <SignupStep2
          firebaseUid={firebaseUid}
          email={email}
          onComplete={(data) => mergeAndNext(data, 3)}
        />
      )}
      {step === 3 && (
        <SignupStep3
          onComplete={(data) => mergeAndNext(data, 4)}
        />
      )}
      {step === 4 && (
        <SignupStep4
          onSkip={() => mergeAndNext({}, 5)}
          onComplete={(data) => mergeAndNext(data, 5)}
        />
      )}
      {step === 5 && (
        <SignupStep5
          allUserData={{ ...collectedData, firebaseUid, email }}
        />
      )}
    </div>
  );
}